import { render } from "./Productos.vue?vue&type=template&id=1bce16a2&scoped=true"
import script from "./Productos.vue?vue&type=script&lang=js"
export * from "./Productos.vue?vue&type=script&lang=js"

import "./Productos.vue?vue&type=style&index=0&id=1bce16a2&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bce16a2"]])

export default __exports__